import './instrument';
import ReactDOM from 'react-dom/client';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { reportError } from './lib/reportError';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => reportError(error, { source: 'query' }),
  }),
  mutationCache: new MutationCache({
    onError: (error) => reportError(error, { source: 'mutation' }),
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
